import ArgonBox from 'components/ArgonBox'
import React from 'react'

const Komponen = () => {
    return (
        <ArgonBox py={3}>

        </ArgonBox>
    )
}

export default Komponen